import { SET_LOCATIONS } from '../constants/action-types';
export const DEFAULT_STATE = [];
// eslint-disable-next-line @typescript-eslint/default-param-last
export const data = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_LOCATIONS:
            return action.payload.locations;
        default:
            return state;
    }
};
